import { render, staticRenderFns } from "./Contentdetail.vue?vue&type=template&id=ceed1f82"
import script from "./Contentdetail.vue?vue&type=script&lang=js"
export * from "./Contentdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports